/**
 * Only supports IE9+
 */
export default {
    delete: function(url, successFunction, errorFunction) {
        let request = new XMLHttpRequest();
        request.open('DELETE', url, true);
        request.onload = function() {
            if(request.status >= 200 && request.status < 400) {
                successFunction(request.responseText);
            } else {
                errorFunction();
            }
        };
        request.onerror = errorFunction;
        request.send();
    },

    deleteJson: function(url, successFunction, errorFunction) {
        let request = new XMLHttpRequest();
        request.open('DELETE', url, true);
        request.onload = function() {
            if((request.status >= 200 && request.status < 400) || request.status === 404) {
                let responseData = JSON.parse(request.responseText);
                successFunction({
                    response: responseData,
                    status: request.status
                });
            } else {
                errorFunction({
                    status: request.status
                });
            }
        };
        request.onerror = errorFunction;
        request.send();
    },

    get: function(url, successFunction, errorFunction) {
        let request = new XMLHttpRequest();
        request.open('GET', url, true);
        request.onload = function() {
            if(request.status >= 200 && request.status < 400) {
                successFunction(request.responseText);
            } else {
                errorFunction();
            }
        };
        request.onerror = errorFunction;
        request.send();
    },

    getJson: function(url, successFunction, errorFunction) {
        let request = new XMLHttpRequest();
        request.open('GET', url, true);
        request.onload = function() {
            if((request.status >= 200 && request.status < 400) || request.status === 404) {
                let responseData = JSON.parse(request.responseText);
                successFunction({
                    response: responseData,
                    status: request.status
                });
            } else {
                errorFunction({
                    status: request.status
                });
            }
        };
        request.onerror = errorFunction;
        request.send();
    },

    post: function(url, data, successFunction, errorFunction) {
        let request = new XMLHttpRequest();
        request.open('POST', url, true);
        request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
        request.onload = function() {
            if(request.status >= 200 && request.status < 400) {
                successFunction(request.responseText);
            } else {
                errorFunction();
            }
        };
        request.onerror = errorFunction;
        request.send(data);
    },

    postJson: function(url, data, successFunction, errorFunction) {
        let request = new XMLHttpRequest();
        request.open('POST', url, true);
        request.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
        request.onload = function() {
            if(request.status < 500) {
                let responseData = !request.responseText ? {} : JSON.parse(request.responseText);

                if((request.status >= 200 && request.status < 400) || request.status === 404) {
                    successFunction({
                        response: responseData,
                        status: request.status
                    });
                } else {
                    errorFunction({
                        response: responseData,
                        status: request.status
                    });
                }
            } else {
                errorFunction({
                    status: request.status
                });
            }
        };
        request.onerror = errorFunction;
        request.send(JSON.stringify(data));
    },

    get: function(url, successFunction, errorFunction) {
        let request = new XMLHttpRequest();
        request.open('DELETE', url, true);
        request.onload = function() {
            if(request.status >= 200 && request.status < 400) {
                successFunction(request.responseText);
            } else {
                errorFunction();
            }
        };
        request.onerror = errorFunction;
        request.send();
    },
};



// WEBPACK FOOTER //
// ./app/assets/javascripts/lib/utils/requests.es6.js